import dayjs from "dayjs"
import IParser from "@/types/IParser"
import ParseError from "@/types/ParseError"
import { safeDayjs } from "@/helpers/dateHelper"
import { ServiceConfig } from "@/models/admin/serviceConfig/serviceConfig"
import { IServiceConfig } from "@/models/admin/serviceConfig/serviceConfig.types"
import { GetBeFinancialsConfigListQuery } from "@/api/hasura/generated/graphql"

// Raw type derived from the generated Hasura query result.
export type ServiceConfigRaw =
  GetBeFinancialsConfigListQuery["financials_configuration"][number]

export const ServiceConfigParser: IParser<IServiceConfig, ServiceConfigRaw> = {
  toDomain(data) {
    try {
      return new ServiceConfig(
        data.id,
        data.name,
        data.value,
        safeDayjs(data.from_dttm) ?? null,
        safeDayjs(data.to_dttm) ?? null,
        dayjs(data.created_at ?? undefined),
        safeDayjs(data.updated_at) ?? null,
        safeDayjs(data.deleted) ?? null,
      )
    } catch (error) {
      throw new ParseError(error)
    }
  },
}
